import React, { useState, useContext, Fragment, useEffect } from 'react';
import Traductor from './Traductor';
import Input from './bronson/Input';
import { UserContext } from '../contexts/UserContext';
import Select from './bronson/Select';
import RadioButton from './bronson/RadioButton';
import { withCookies } from 'react-cookie';
import ParseService from '../services/ParseService';
import TransportService from '../services/TransportService';
import Globals from '../Globals';
import { IsNullORWhitespace } from './../Functions';
import Button from './bronson/Button';
import ModalExposureBrand from './preferences/ModalExposureBrand';

function PreferenceModule({ cookies, options, data, parentSubmit }) {
    const t = new Traductor();
    const { user } = useContext(UserContext);
    const [defaultItem] = useState({ value: '', text: 'Seleccionar' });
    const [radiobuttonIncludetransportComponent] = useState(false);
    const [radiobuttonIncludeManualOrConcesionarieComponent] = useState(false);
    const [
        transportDataConsesionarieComponent,
        settransportDataConsesionarieComponent,
    ] = useState(false);
    const [
        transportDataStreetTypePreference,
        settransportDataStreetTypePreference,
    ] = useState(false);
    const [transportDataWayPreference, settransportWayPreference] = useState(
        false
    );
    const [
        transportDataNumberWayPreference,
        settransportDataNumberWayPreference,
    ] = useState(false);
    const [transportDataCodezip, settransportDataCodezip] = useState(false);
    const [transportDataPoblation, settransportDataPoblation] = useState(false);
    const [ConsesionarieDataEstadisticsComponent] = useState(false);
    const [BranchDataEstadisticsComponent] = useState(false);
    const [
        showcomponentDatasTransport,
        SetshowcomponentDatasTransport,
    ] = useState(data.IncludeTransport);
    const [showdrownboxConsesionarie, setshowdrownboxConsesionarie] = useState(
        false
    );

    const [form, setForm] = useState(data);
    const [listInstallationTransport, setInstallationTransport] = useState([
        defaultItem,
    ]);
    const [listInstallation, setInstallation] = useState([defaultItem]);
    const [listStreetType, setListStreetType] = useState([defaultItem]);
    const [listPoblation, setListPoblation] = useState([defaultItem]);
    const [lstMarca, setLstMarca] = useState([defaultItem]);
    const [errorList, setError] = useState({});
    const [errorModal, setErrorModal] = useState(false);

    useEffect(() => {
        if (user.logged) {
            LoadData();
            if (data.PreferenceId == 0) {
                SetDefaultBuyer();
            }
        }
    }, []);

    useEffect(() => {
        if (parentSubmit) {
            onClickButton();
            options.button.reset(false);
        }
    }, [parentSubmit]);

    useEffect(() => {
        if (
            options?.transport?.getTransport &&
            options?.transport?.selectedVehicle
        ) {
            if (
                form.ZipCode != '' &&
                options.transport.selectedVehicle.HasTransportAvailable &&
                options.transport.userHasTransportAvailable
            ) {
                calculatePriceTransport(options.transport.selectedVehicle);
            } else {
                options.transport.function({
                    Term: 0,
                    TransportPrice: null,
                    DestinationLocationId: 0,
                });
            }
        }
    }, [form.ZipCode]);

    useEffect(() => {
        if (errorModal.error == true) {
            setErrorModal(state => ({
                ...state,
                show: true,
            }));
        } else {
            setErrorModal(state => ({
                ...state,
                show: false,
            }));
        }
    }, [errorModal.error]);

    const onChange = (value, property) => {
        setForm(form => ({ ...form, [property]: value }));
    };

    const onError = (name, value) => {
        setError({ ...errorList, [name]: value });
    };

    const showError = property => {
        return errorList[property];
    };

    const LoadData = () => {
        if (form.CifBuyer != '') {
            setValuesForDealerExposition(form.CifBuyer);
            setValuesForDestination(form.CifBuyer);
        }

        if (form.CodconsesionarieEstadistics != '') {
            setValuesForBranchDestination(form.CodconsesionarieEstadistics);
        }

        if (form.CodconsesionarierBuyer != '' && form.IsDealerTransport) {
            BlockTransportDataOnchangeConsesionarie();
        }

        LoadStreetType();
        LoadPoblation(form.ZipCode);
    };

    const SetDefaultBuyer = () => {
        if (user.cifs && user.cifs.length == 1) {
            let buyer = user.cifs[0];
            setForm({
                ...form,
                CifBuyer: buyer.CIF,
                ClientId: buyer.Id,
            });
        }
    };

    //METODOS DE LISTADOS
    const setValuesForSelect = () => {
        let values = [defaultItem];
        if (user.cifs && user.cifs.length > 0) {
            // if (user.cifs.length > 1) {
            //   values.push(defaultItem);
            // }
            user.cifs.map(cif => {
                values.push({ value: cif.CIF, text: cif.Name });
            });
        } else {
            if (user.cifs && user.cifs.length == 1) {
                values.push({
                    value: user.cifs[0].CIF,
                    text: user.cifs[0].Name,
                });
            }
        }
        return values;
    };

    const onBuyerChange = (value, property) => {
        setLstMarca([defaultItem]);
        let clientId = 0;
        if (
            user.cifs.filter(function (item) {
                return item.CIF === value;
            })[0]
        ) {
            //TODO: usar jslinq
            clientId = user.cifs.filter(function (item) {
                return item.CIF === value;
            })[0].Id;
        }

        var data = { ...form };
        data.CifBuyer = value;
        data.ClientId = clientId;
        data.CodconsesionarierBuyer = '';
        data.NameconsesionarierBuyer = '';
        data.StreetType = '';
        data.StreetName = '';
        data.StreetNumber = '';
        data.ZipCode = '';
        data.ProvinciesCode = '';
        data.CodePoblation = '';
        data.MunicipalityCode = '';
        data.ProvinceName = '';
        data.CodconsesionarieEstadistics = '';
        data.BrandCode = '';

        setForm(data);
        setListPoblation([defaultItem]);
        setValuesForDealerExposition(value);
        setValuesForDestination(value);
    };

    const onDealerTransportChange = (value, property) => {
        if (value != '') {
            GetdataConsesionarie(value);
        } else {
            ResetTransportData();
        }
    };

    const onDealerChange = (value, property) => {
        setLstMarca([defaultItem]);
        setForm(form => ({
            ...form,
            [property]: value,
            BrandCode: '',
        }));
        // onChange(value, property);
        // onChange('', "BrandCode");
        setValuesForBranchDestination(value);
    };

    const setValuesForDestination = cif => {
        let childrenCifs = [defaultItem];
        if (!IsNullORWhitespace(cif)) {
            if (user.data.Dealers) {
                var dealers = user.data.Dealers.filter(
                    d => d.CIF.toUpperCase() == cif.toUpperCase()
                );
                // if (form.CodconsesionarierBuyer == "" || user.cifs.length > 1) {
                //   childrenCifs.push(defaultItem);
                // }
                dealers.map(childrencif => {
                    childrenCifs.push({
                        value: childrencif.Id,
                        text: childrencif.Name,
                    });
                });
                setInstallationTransport(childrenCifs);
            }
        }
    };

    const setValuesForDealerExposition = cif => {
        let childrenCifs = [];
        if (!IsNullORWhitespace(cif)) {
            if (user.data.Dealers) {
                var dealers = user.data.Dealers.filter(
                    d => d.CIF.toUpperCase() == cif.toUpperCase()
                );
                //if (form.CodconsesionarieEstadistics != "" || user.cifs.length > 1) { childrenCifs.push(defaultItem); }
                childrenCifs.push(defaultItem);
                dealers.map(childrencif => {
                    childrenCifs.push({
                        value: childrencif.VWFCode,
                        text:
                            '(' + childrencif.VWFCode + ') ' + childrencif.Name,
                    });
                });
                setInstallation(childrenCifs);
            }
        }
    };

    //OPCIONES INPUT
    const optionsCIF = {
        id: 'cif',
        type: 'text',
        name: 'cif',
        text: t.getTraduction('Comprador'),
        showLabel: true,
        values: setValuesForSelect(),
        customAttributes: {
            context: 'CifBuyer',
        },
    };

    const radioOptionsIncludeTransport = {
        id: 'incTransport',
        name: 'inctransport',
        className: '',
        disabled: radiobuttonIncludetransportComponent,
        text: t.getTraduction('IncluirTransporte'),
        showLabel: true,
        values: [
            { text: t.getTraduction('Si'), value: 'S' },
            { text: t.getTraduction('No'), value: 'N' },
        ],
    };

    const radiodirectionConsesionarie = {
        id: 'dealerTransport',
        name: 'incConsesionarie',
        showLabel: false,
        className: '',
        disabled: radiobuttonIncludeManualOrConcesionarieComponent,
        values: [
            { text: t.getTraduction('Aconcesionario'), value: 'S' },
            { text: t.getTraduction('Otras'), value: 'N' },
        ],
        customAttributes: {
            context: 'IsDealerTransport',
        },
    };

    const OptionsInstallation = {
        id: 'Installation',
        type: 'text',
        name: 'Installation',
        text: t.getTraduction('Installation'),
        disabled: transportDataConsesionarieComponent,
        values: listInstallationTransport,
        showLabel: true,
        customAttributes: {
            context: 'CodconsesionarierBuyer',
        },
    };

    const TituloDestinoPreferencia = {
        id: 'DestinoPreferenciadato',
        type: 'text',
        name: 'DestinoPreferenciadato',
        event: true,
        placeHolder: t.getTraduction('PlaceHolderDestiny'),
        disabled: transportDataStreetTypePreference,
        name: 'DestinoPreferenciadato',
        label: t.getTraduction('DestinoPreferenciadato'),
    };

    const OptionsTypeVia = {
        id: 'OptionsTypeVia:',
        type: 'text',
        name: 'OptionsTypeVia:',
        text: t.getTraduction('OptionsTypeVia'),
        values: listStreetType,
        disabled: transportDataStreetTypePreference,
        showLabel: true,
        customAttributes: {
            context: 'StreetType',
        },
    };

    const OptionsVia = {
        id: 'Way',
        type: 'text',
        name: 'Way',
        event: true,
        name: 'Way',
        disabled: transportDataWayPreference,
        label: t.getTraduction('OptionsVia'),
        custom: {
            context: 'StreetName',
        },
    };

    const OptionsWay = {
        id: 'NumberWay',
        type: 'text',
        name: 'Nª',
        event: true,
        name: 'NumberWay',
        disabled: transportDataNumberWayPreference,
        label: t.getTraduction('NumberWay'),
        custom: {
            context: 'StreetNumber',
        },
    };

    const OptionsPostalCode = {
        id: 'PostalCode',
        type: 'text',
        name: 'CP',
        event: true,
        disabled: transportDataCodezip,
        name: 'PostalCode',
        label: t.getTraduction('PostalCodeLabel'),
        custom: {
            context: 'ZipCode',
        },
    };

    const OptionsCity = {
        id: 'City',
        type: 'text',
        name: 'City',
        disabled: true,
        label: t.getTraduction('CityLabel'),
    };

    // const OptionsOptional = {
    //   id: "optional",
    //   type: "text",
    //   name: "optional",
    //   disabled: transportDataComponents,
    //   label: t.getTraduction("Optional")
    // };

    const OptionsPoblation = {
        id: 'Poblation',
        type: 'text',
        name: 'Poblation',
        text: t.getTraduction('PoblationLabel'),
        disabled: transportDataPoblation,
        values: listPoblation,
        showLabel: true,
        custom: {
            context: 'CodePoblation',
        },
    };

    const OptionsInstallationExposition = {
        id: 'InstallationExposition',
        type: 'text',
        name: 'InstallationExposition',
        disabled: ConsesionarieDataEstadisticsComponent,
        text: t.getTraduction('InstallationExposition'),
        values: listInstallation,
        showLabel: true,
        customAttributes: {
            context: 'CodconsesionarieEstadistics',
        },
    };

    const OptionsBranchEstadistics = {
        id: 'BranchEstadistics',
        type: 'text',
        name: 'BranchEstadistics',
        disabled: BranchDataEstadisticsComponent,
        text: t.getTraduction('BranchEstadistics'),
        values: lstMarca,
        showLabel: true,
        custom: {
            context: 'BrandCode',
        },
    };

    let CheckboxPreferencesDeterminated = {
        id: 'CheckboxPreferencesDeterminated',
        type: 'checkbox',
        text: {
            text: t.getTraduction('PreferenciapPrederminada'),
        },
        name: 'tandc',
        event: true,
    };

    const onClickButton = () => {
        if (validate()) {
            let installationEstadisticsSelect = document.getElementById(
                'InstallationExposition-select-element'
            );
            if (installationEstadisticsSelect) {
                form.DealerEstadistics =
                    installationEstadisticsSelect.options[
                        installationEstadisticsSelect.selectedIndex
                    ].text;
            }
            let brandExpositionSelect = document.getElementById(
                'BranchEstadistics-select-element'
            );
            if (brandExpositionSelect) {
                form.BrandExposition =
                    brandExpositionSelect.options[
                        brandExpositionSelect.selectedIndex
                    ].text;
            }
            options.button.function(form);
        } else {
            options.button.function(null);
        }
    };

    const validate = () => {
        let isValid = true;
        let errors = {};
        if (form.CifBuyer != '') {
            errors.CifBuyer = '';
        } else {
            errors.CifBuyer = 'Debe seleccionar un comprador';
            isValid = false;
        }

        if (user.buyerType == 2 || user.buyerType == 8 || user.buyerType == 7) {
            if (user.buyerType == 2) {
                if (form.CodconsesionarieEstadistics !== '') {
                    errors.CodconsesionarieEstadistics = '';
                } else {
                    errors.CodconsesionarieEstadistics =
                        'Debe seleccionar un consesionario estadística';
                    isValid = false;
                }

                if (form.BrandCode !== '') {
                    errors.BrandCode = '';
                } else {
                    errors.BrandCode = 'Debe seleccionar una marca estadística';
                    isValid = false;
                }
            }
            const isTransportVisible =
                options?.transport?.userHasTransportAvailable !== false &&
                (!options?.transport?.selectedVehicle ||
                    options?.transport?.selectedVehicle?.HasTransportAvailable !== false);
            if (form.IncludeTransport == true && isTransportVisible) {
                if (form.IsDealerTransport == false) {
                    if (form.StreetType != '' && form.StreetType != null) {
                        errors.StreetType = '';
                    } else {
                        errors.StreetType = 'Debe introducir un tipo de vía';
                        isValid = false;
                    }

                    if (form.StreetName !== '' && form.StreetName != null) {
                        errors.StreetName = '';
                    } else {
                        errors.StreetName = 'Debe introducir un nombre de vía';
                        isValid = false;
                    }
                    if (form.StreetNumber !== '' && form.StreetNumber != null) {
                        errors.StreetNumber = '';
                    } else {
                        errors.StreetNumber =
                            'Debe introducir un número de vía';
                        isValid = false;
                    }

                    if (
                        form.CodePoblation !== '' &&
                        form.CodePoblation != null
                    ) {
                        errors.CodePoblation = '';
                    } else {
                        errors.CodePoblation = 'Debe Seleccionar una población';
                        isValid = false;
                    }

                    if (form.ZipCode != '' && form.ZipCode != null) {
                        if (form.ZipCode.length != 5) {
                            errors.ZipCode =
                                'El valor numérico ha de contener una longitud de 5';
                            isValid = false;
                        } else if (isNaN(form.ZipCode)) {
                            errors.ZipCode = 'Tiene que ser numérico';
                            isValid = false;
                        } else {
                            errors.ZipCode = '';
                        }
                    } else {
                        errors.ZipCode = 'Debe introducir un código postal';
                        isValid = false;
                    }
                } else {
                    if (
                        (form.CodconsesionarierBuyer !== '' &&
                            form.CodconsesionarierBuyer != null) ||
                        options?.transport?.selectedVehicle
                            ?.RepurchaseObligation >= 0
                    ) {
                        errors.CodconsesionarierBuyer = '';
                    } else {
                        errors.CodconsesionarierBuyer =
                            'Debe seleccionar un Consesionario';
                        isValid = false;
                    }
                }
            }
        }

        setError(errors);
        return isValid;
    };

    const LoadStreetType = async () => {
        let _listStreetType = [];
        let ListStreetTypedatabase = await new TransportService().getStreetType(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        let ListStreetTypedata = new ParseService().Parse(
            ListStreetTypedatabase.body.Result
        );
        if (
            ListStreetTypedata &&
            ListStreetTypedata !== undefined &&
            ListStreetTypedata.length > 0
        ) {
            if (form.StreetType == '' || ListStreetTypedata.length > 1) {
                _listStreetType.push(defaultItem);
            }
            ListStreetTypedata.map(StreetType => {
                _listStreetType.push({
                    value: StreetType.CodeWay,
                    text: StreetType.DescriptionWay,
                });
            });
        }
        setListStreetType(_listStreetType);
    };

    async function handleChangeZipCode(e, property) {
        let codeZip = e.target.value;
        onChange(codeZip, property);
        if (codeZip.length == 5 && !Number.isNaN(codeZip)) {
            onError('ZipCode', '');
            await new TransportService()
                .getCodeProvince(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    codeZip
                )
                .then(response => {
                    let city = response.Result;
                    onChange(city, 'ProvinceName');
                    LoadPoblation(codeZip);
                });
        } else {
            if (isNaN(form.ZipCode)) {
                onError('ZipCode', 'Tiene que ser un valor numérico');
            } else if (IsNullORWhitespace(form.ZipCode)) {
                onError('ZipCode', 'El campo no puede estar vacio');
            } else if (codeZip.length != 5) {
                onError(
                    'ZipCode',
                    'El valor numérico debe tener una longitud de 5'
                );
            } else {
                onError('ZipCode', 'Error');
            }
            setListPoblation([defaultItem]);
        }
    }

    async function LoadPoblation(CP) {
        let ListPoblation = [];
        if (!CP) return;
        await new TransportService()
            .getPoblationByCodeZip(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                CP
            )
            .then(response => {
                if (response) {
                    let ListPoblationdata = new ParseService().Parse(
                        response.body.Result
                    );
                    if (
                        ListPoblationdata != undefined &&
                        ListPoblationdata.length > 0
                    ) {
                        if (ListPoblationdata[0].Id) {
                            onChange(ListPoblationdata[0].Id, 'CodePoblation');
                        }
                        if (ListPoblationdata.length > 1) {
                            ListPoblation.push(defaultItem);
                        }
                        ListPoblationdata.map(poblation => {
                            ListPoblation.push({
                                value: poblation.Id,
                                text: poblation.Description,
                            });
                        });
                    }
                    setListPoblation(ListPoblation);
                }
            });
    }

    async function GetdataConsesionarie(e) {
        let IdCanalConsesionarieEstadistic = e;
        let ResponseDatasConsesionarieEstadistic = await new TransportService().GetdataConsesionarie(
            cookies.get(Globals.COOKIES.JWT).AccessToken,
            IdCanalConsesionarieEstadistic
        );
        let datasConsesionarieEsta = new ParseService().Parse(
            ResponseDatasConsesionarieEstadistic.body.Result
        );
        SetDataConsesionarie(datasConsesionarieEsta);
    }

    const onChangeCity = e => {
        return null;
    };

    // const onChangeTitleDestiny = e => {
    //   SetTitleDestiny(e.target.value);
    //   form.TitleDestiny = e.target.value;
    // };

    const onChangeVia = (e, property) => {
        onChange(e.currentTarget.value, property);
    };

    const onChangeNumberWay = (e, property) => {
        onChange(e.currentTarget.value, property);
    };

    function onChangePoblation(value, property) {
        onChange(value, property);
    }

    function onChangeCheckboxPreferencesDeterminated(e) {
        //    SetCheckPreferencePredeterminated(e.target.checked);
    }

    //-----------//

    //SETEAR DATOS
    function SetDataConsesionarie(dealer) {
        var nameDealer = '';
        if (
            dealer.DealerId &&
            listInstallationTransport &&
            listInstallationTransport.length > 0
        ) {
            Object.keys(listInstallationTransport).map(item => {
                if (listInstallationTransport[item].value == dealer.DealerId)
                    nameDealer = listInstallationTransport[item].text;
            });
        }

        var dealerName = form.CodconsesionarieEstadistics;
        var brandCode = form.BrandCode;
        if (data.CodconsesionarierBuyer != form.CodconsesionarierBuyer) {
            dealerName = '';
            brandCode = '';
            setLstMarca([defaultItem]);
        }

        setForm(form => ({
            ...form,
            CodconsesionarierBuyer: dealer.DealerId,
            NameconsesionarierBuyer: nameDealer,
            StreetType: dealer.TypeWay,
            StreetName: dealer.Address,
            StreetNumber: dealer.AddressNumber,
            ZipCode: dealer.PostalCode,
            ProvinciesCode: dealer.ProvinceCode,
            ProvinceName: dealer.ProvinceName,
            CodePoblation: dealer.MunicipalityCode,
            MunicipalityCode: dealer.MunicipalityCode,
            CodconsesionarieEstadistics: dealerName,
            BrandCode: brandCode,
        }));

        let ListPoblation = [];
        ListPoblation.push({
            value: dealer.MunicipalityCode,
            text: dealer.MunicipalityDescription,
        });
        setListPoblation(ListPoblation);
    }

    async function setValuesForBranchDestination(e) {
        let branchDestinations = [];
        if (e && e != '') {
            let branchEstadistics = await new TransportService().getBranchEstadistics(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                e
            );
            let ListBranchEstadistics = new ParseService().Parse(
                branchEstadistics.body.Result
            );
            if (
                ListBranchEstadistics != undefined &&
                ListBranchEstadistics != null
            ) {
                if (ListBranchEstadistics.length > 0) {
                    branchDestinations.push(defaultItem);
                    ListBranchEstadistics.map(branchDestination => {
                        branchDestinations.push({
                            value: branchDestination.Id,
                            text: branchDestination.Description,
                        });
                    });
                } else {
                    branchDestinations.push({
                        value: '-1',
                        text: 'Sin marcas disponibles',
                    });
                    setErrorModal({
                        error: true,
                        show: false,
                    });
                }
            }
            setLstMarca(branchDestinations);
        }
    }

    const SetHasTransport = value => {
        LoadStreetType();
        if (value == 'N') {
            var data = { ...form };
            data.IncludeTransport = false;
            data.IsDealerTransport = false;
            data.TransportId = '';
            data.CodconsesionarierBuyer = '';
            data.NameconsesionarierBuyer = '';
            data.StreetType = '';
            data.StreetName = '';
            data.StreetNumber = '';
            data.ZipCode = '';
            data.ProvinciesCode = '';
            data.CodePoblation = '';
            data.MunicipalityCode = '';
            data.ProvinceName = '';
            setForm(data);
            SetshowcomponentDatasTransport(false);
        } else {
            form.IncludeTransport = true;
            SetshowcomponentDatasTransport(true);
        }
    };

    const onRadioChange = (value, property) => {
        ResetTransportData();
        if (value === 'N') {
            onChange(false, property);
            EnabledTransportDataOnchangeConsesionarie();
            setshowdrownboxConsesionarie(false);
        } else {
            onChange(true, property);
            setValuesForDestination(form.CifBuyer);
            BlockTransportDataOnchangeConsesionarie();
        }
    };

    const ResetTransportData = () => {
        var data = { ...form };
        data.CodconsesionarierBuyer = '';
        data.NameconsesionarierBuyer = '';
        data.StreetType = '';
        data.StreetName = '';
        data.StreetNumber = '';
        data.ZipCode = '';
        data.ProvinciesCode = '';
        data.CodePoblation = '';
        data.MunicipalityCode = '';
        data.ProvinceName = '';
        setForm(data);
        setListPoblation([defaultItem]);
    };

    function BlockTransportDataOnchangeConsesionarie() {
        setshowdrownboxConsesionarie(true);
        settransportDataConsesionarieComponent(false);
        settransportDataStreetTypePreference(true);
        settransportWayPreference(true);
        settransportDataNumberWayPreference(true);
        settransportDataCodezip(true);
        settransportDataPoblation(true);
        settransportDataStreetTypePreference(true);
    }

    function EnabledTransportDataOnchangeConsesionarie() {
        setshowdrownboxConsesionarie(true);
        settransportDataStreetTypePreference(false);
        settransportWayPreference(false);
        settransportDataNumberWayPreference(false);
        settransportDataCodezip(false);
        settransportDataPoblation(false);
    }

    async function calculatePriceTransport(selectedVehicle) {
        var calculatePriceTransportRequest = {
            VehicleId: selectedVehicle?.Id,
            OriginType:
                selectedVehicle?.Origin?.Type ||
                selectedVehicle?.OriginType ||
                0,
            LocationId:
                selectedVehicle?.Origin?.LocationId ||
                selectedVehicle?.LocationId,
            OriginId: selectedVehicle?.Origin?.Id || selectedVehicle?.OriginId,
            PostalCode: form.ZipCode,
        };

        const Province =
            selectedVehicle?.Origin?.Province || selectedVehicle?.Province;

        if (Province != 35 && Province != '38') {
            let datapriceResponse = await new TransportService().getTransportPrice(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                calculatePriceTransportRequest
            );
            if (
                datapriceResponse != null &&
                datapriceResponse != undefined &&
                datapriceResponse.Result != null
            ) {
                let DataTransportprice = new ParseService().Parse(
                    datapriceResponse.Result
                );
                options.transport.function(DataTransportprice);
            } else {
                options.transport.function({
                    Term: 0,
                    TransportPrice: null,
                    DestinationLocationId: null,
                    Msg:
                        'No se ha podido calcular el precio del transporte, póngase en contacto con VWFS',
                });
            }
        } else {
            options.transport.function({
                Term: 0,
                TransportPrice: null,
                DestinationLocationId: null,
                Msg: 'Los vehículos de Canarias no disponen de transporte',
            });
        }
    }

    const dataShipment = () => {
        return (
            <Fragment>
                <div className="o-fieldset__row rema-border-d8">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-h3 u-mb">
                                {t.getTraduction('DatosComprador')}
                            </p>
                            <Select
                                onChange={e =>
                                    onBuyerChange(
                                        e,
                                        optionsCIF.customAttributes.context
                                    )
                                }
                                value={
                                    IsNullORWhitespace(form.CifBuyer)
                                        ? ''
                                        : form.CifBuyer
                                }
                                options={optionsCIF}
                            ></Select>
                            <p className="c-error-message" id="CifBuyerError">
                                {errorList.CifBuyer}
                            </p>
                        </div>
                    </div>
                </div>
                {(user.buyerType == 2 ||
                    user.buyerType == 1 || // compra-ventas
                    user.buyerType == 8 ||
                    user.buyerType == 7) && (
                    <Fragment>
                        {((options.transport.userHasTransportAvailable &&
                            !options.transport.selectedVehicle) ||
                            (options &&
                                options.transport &&
                                options.transport.selectedVehicle &&
                                options.transport.selectedVehicle
                                    .HasTransportAvailable &&
                                options.transport
                                    .userHasTransportAvailable)) && (
                            <div className="rema-border-d8">
                                <div className="o-fieldset__row">
                                    <div className="o-layout">
                                        <div className="o-layout__item u-1/1">
                                            <p className="u-h3 u-mb">
                                                {t.getTraduction(
                                                    'TituloTransporte'
                                                )}
                                            </p>
                                            <RadioButton
                                                value={
                                                    form.IncludeTransport
                                                        ? 'S'
                                                        : 'N'
                                                }
                                                options={
                                                    radioOptionsIncludeTransport
                                                }
                                                onChange={SetHasTransport}
                                            ></RadioButton>
                                        </div>
                                    </div>
                                </div>

                                {showcomponentDatasTransport && (
                                    <Fragment>
                                        <div className="o-fieldset__row">
                                            <div className="o-layout">
                                                <div className="o-layout__item u-1/1">
                                                    <RadioButton
                                                        value={
                                                            form.IsDealerTransport
                                                                ? 'S'
                                                                : 'N'
                                                        }
                                                        options={
                                                            radiodirectionConsesionarie
                                                        }
                                                        onChange={e =>
                                                            onRadioChange(
                                                                e,
                                                                radiodirectionConsesionarie
                                                                    .customAttributes
                                                                    .context
                                                            )
                                                        }
                                                    ></RadioButton>
                                                </div>

                                                {showdrownboxConsesionarie && (
                                                    <Fragment>
                                                        <div
                                                            className="o-layout__item u-1/1"
                                                            id="installationelement"
                                                        >
                                                            <Select
                                                                onChange={e =>
                                                                    onDealerTransportChange(
                                                                        e,
                                                                        OptionsInstallation
                                                                            .customAttributes
                                                                            .context
                                                                    )
                                                                }
                                                                value={
                                                                    form.CodconsesionarierBuyer
                                                                }
                                                                options={
                                                                    OptionsInstallation
                                                                }
                                                            ></Select>
                                                            <p
                                                                className="c-error-message"
                                                                id="CodConsesionarierBuyerError"
                                                            >
                                                                {
                                                                    errorList.CodconsesionarierBuyer
                                                                }
                                                            </p>
                                                        </div>
                                                    </Fragment>
                                                )}
                                                {/* {showcomponentdestiny && (
                        <Fragment>
                          <div className="o-layout__item u-2/4 u-1/1@s" id="TitleDestiny">
                            <Input
                              onChange={e => onChangeTitleDestiny(e)}
                              value={InitTitleDestiny}
                              options={TituloDestinoPreferencia}
                            ></Input>
                          </div>
                        </Fragment>
                      )} */}
                                                <div
                                                    className="o-layout__item u-1/4 u-1/1@s"
                                                    id="TypeVia"
                                                >
                                                    <Select
                                                        onChange={e =>
                                                            onChange(
                                                                e,
                                                                OptionsTypeVia
                                                                    .customAttributes
                                                                    .context
                                                            )
                                                        }
                                                        value={form.StreetType}
                                                        options={OptionsTypeVia}
                                                    ></Select>
                                                    <p
                                                        className="c-error-message"
                                                        id="StreetTypeError"
                                                    >
                                                        {errorList.StreetType}
                                                    </p>
                                                </div>

                                                <div
                                                    className="o-layout__item u-3/4 u-1/1@s"
                                                    id="via"
                                                >
                                                    <Input
                                                        onChange={e =>
                                                            onChangeVia(
                                                                e,
                                                                OptionsVia
                                                                    .custom
                                                                    .context
                                                            )
                                                        }
                                                        value={form.StreetName}
                                                        options={OptionsVia}
                                                    ></Input>
                                                    <p
                                                        className="c-error-message"
                                                        id="StreetNameError"
                                                    >
                                                        {errorList.StreetName}
                                                    </p>
                                                </div>
                                                <div
                                                    className="o-layout__item u-1/4 u-1/1@s"
                                                    id="NumberWay"
                                                >
                                                    <Input
                                                        onChange={e =>
                                                            onChangeNumberWay(
                                                                e,
                                                                OptionsWay
                                                                    .custom
                                                                    .context
                                                            )
                                                        }
                                                        value={
                                                            form.StreetNumber
                                                        }
                                                        options={OptionsWay}
                                                    ></Input>
                                                    <p
                                                        className="c-error-message"
                                                        id="NumberWayError"
                                                    >
                                                        {errorList.StreetNumber}
                                                    </p>
                                                </div>
                                                <div className="o-layout__item u-1/4 u-1/1@s customelement">
                                                    <Input
                                                        onChange={e =>
                                                            handleChangeZipCode(
                                                                e,
                                                                OptionsPostalCode
                                                                    .custom
                                                                    .context
                                                            )
                                                        }
                                                        options={
                                                            OptionsPostalCode
                                                        }
                                                        value={form.ZipCode}
                                                    ></Input>
                                                    <p
                                                        className="c-error-message"
                                                        id="CityError"
                                                    >
                                                        {errorList.ZipCode}
                                                    </p>
                                                </div>
                                                <div className="o-layout__item  u-2/4  u-1/1@s customelement">
                                                    <Input
                                                        options={OptionsCity}
                                                        value={
                                                            form.ProvinceName
                                                        }
                                                        onChange={e =>
                                                            onChangeCity(e)
                                                        }
                                                    ></Input>
                                                    <p
                                                        className="c-error-message"
                                                        id="CityError"
                                                    >
                                                        {errorList.CityError}
                                                    </p>
                                                </div>
                                                <div
                                                    className="o-layout__item u-4/4 u-1/1@s"
                                                    id="Poblation"
                                                >
                                                    <Select
                                                        onChange={e =>
                                                            onChangePoblation(
                                                                e,
                                                                OptionsPoblation
                                                                    .custom
                                                                    .context
                                                            )
                                                        }
                                                        value={
                                                            form.CodePoblation
                                                        }
                                                        options={
                                                            OptionsPoblation
                                                        }
                                                    ></Select>
                                                    <p
                                                        className="c-error-message"
                                                        id="PoblationError"
                                                    >
                                                        {
                                                            errorList.CodePoblation
                                                        }
                                                    </p>
                                                </div>
                                                {false && (
                                                    <Fragment>
                                                        <div
                                                            className="o-layout__item u-1/1"
                                                            id="preferencesdeterminated"
                                                        >
                                                            <Input
                                                                options={
                                                                    CheckboxPreferencesDeterminated
                                                                }
                                                                onChange={e =>
                                                                    onChangeCheckboxPreferencesDeterminated(
                                                                        e
                                                                    )
                                                                }
                                                            ></Input>
                                                            <p
                                                                className="c-error-message"
                                                                id="tandcError"
                                                            >
                                                                {showError(
                                                                    errorList.tandcError
                                                                )}
                                                            </p>
                                                        </div>
                                                    </Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </div>
                        )}
                        {user.buyerType == 2 && (
                            <div className="o-fieldset__row u-mt rema-border-d8">
                                <div className="o-layout">
                                    <div className="o-layout__item u-1/1">
                                        <p className="u-h3">
                                            {t.getTraduction(
                                                'DatosEstadisticos'
                                            )}
                                        </p>
                                    </div>

                                    <div
                                        className="o-layout__item u-1/2 u-1/1@l"
                                        id="consesionarieEstadistic"
                                    >
                                        <Select
                                            onChange={e =>
                                                onDealerChange(
                                                    e,
                                                    OptionsInstallationExposition
                                                        .customAttributes
                                                        .context
                                                )
                                            }
                                            value={
                                                IsNullORWhitespace(
                                                    form.CodconsesionarieEstadistics
                                                )
                                                    ? ''
                                                    : form.CodconsesionarieEstadistics
                                            }
                                            options={
                                                OptionsInstallationExposition
                                            }
                                        ></Select>
                                        <p
                                            className="c-error-message"
                                            id="CodconsesionarieEstadistics"
                                        >
                                            {
                                                errorList.CodconsesionarieEstadistics
                                            }
                                        </p>
                                    </div>

                                    <div
                                        className="o-layout__item u-1/2 u-1/1@l"
                                        id="installationelementBranchEstadistic"
                                    >
                                        <Select
                                            onChange={e =>
                                                onChange(
                                                    e,
                                                    OptionsBranchEstadistics
                                                        .custom.context
                                                )
                                            }
                                            value={
                                                IsNullORWhitespace(
                                                    form.BrandCode
                                                )
                                                    ? ''
                                                    : form.BrandCode
                                            }
                                            options={OptionsBranchEstadistics}
                                        ></Select>
                                        <p
                                            className="c-error-message"
                                            id="BranchExpositionError"
                                        >
                                            {errorList.BrandCode}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Fragment>
                )}
            </Fragment>
        );
    };

    const printSaveButton = () => {
        if (options && options.button && options.button.text) {
            let optionsBtnSavePreferences = {
                text: options.button.text ? options.button.text : '',
                disabled: options.button.disabled
                    ? options.button.disabled
                    : false,
                id: 'btnSavePreferences',
                class: '',
            };
            return (
                <Button
                    options={optionsBtnSavePreferences}
                    onClick={() => onClickButton()}
                ></Button>
            );
        } else return null;
    };

    const printErrorModal = () => {
        if (Object.keys(errorModal).length == 0 || !errorModal.show)
            return null;
        return (
            <ModalExposureBrand closeModal={setErrorModal}></ModalExposureBrand>
        );
    };

    return (
        <Fragment>
            <fieldset className="o-fieldset">{dataShipment()}</fieldset>
            {printSaveButton()}
            {printErrorModal()}
        </Fragment>
    );
}

export default withCookies(PreferenceModule);
